import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useStoreByName } from '@web/hooks/use-stores.hooks';

import SourceSelector from '../selections/book-selector';
import LevelsSelectors from '../selections/selectors-levels';
import PreviewTextArea from '../reading-areas/PreviewTextArea';
import { Button, Divider } from '@mui/material';

import BookIcon from '../../../assets/icons/iconBook.svg';

const SelectionReadingPartCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { initializeDefaultBook, initializeFromLastReading } = useStoreByName('booksStore');
  const { userData } = useStoreByName('userStore');

  const buttonHandler = () => {
    navigate('/reading');
  }

  useEffect(() => {
    // Check if we have lastReading data from user
    if (userData?.personalInfo?.lastReading) {
      initializeFromLastReading(userData.personalInfo.lastReading);
    } else {
      initializeDefaultBook();
    }
  }, [initializeDefaultBook, initializeFromLastReading, userData?.personalInfo?.lastReading]);

  return (
    <div className="card reading-part-selection" data-tour="selection-card">
      <div className="container">
        <div className="card-header">
          <div className="column">
            <img src={BookIcon} alt="סמל ספר" />
            <h3>{t('choosePassageForMemorization')}</h3>
          </div>
        </div>
        <div className="content">
          <div className="column">
            <div className="selectors-container" data-tour="selectors">
              <SourceSelector />
              <Divider variant="fullWidth" orientation='horizontal' flexItem sx={{ marginY: 1 }} />
              <LevelsSelectors />
            </div>
          </div>
          <div className="column">
            <PreviewTextArea />
            <Button className="circle" data-tour="start-button" onClick={buttonHandler}>{t('start')}</Button>
          </div>
        </div>
      </div>
    </div>
  )
};

export default observer(SelectionReadingPartCard);
